import { render, staticRenderFns } from "./c-menu@.vue?vue&type=template&id=45ba8b20&"
import script from "./c-menu@.vue?vue&type=script&lang=ts&"
export * from "./c-menu@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports